import type { SVGProps } from "react";

export default function EmptyChatHistoryIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="250"
      height="138"
      viewBox="0 0 117 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="77.4899"
        height="44.3692"
        rx="3.76469"
        transform="matrix(-1 0 0 1 77.4899 15.2236)"
        fill="#444343"
      />
      <path
        d="M7.18653 64.2797L16.5603 59.5928H7.18653V64.2797Z"
        fill="#444343"
      />
      <path
        d="M7.76471 21.4114C7.11497 21.4114 6.58824 21.9381 6.58824 22.5879C6.58824 23.2376 7.11497 23.7644 7.76471 23.7644V22.5879V21.4114ZM7.76471 22.5879V23.7644H39.0587V22.5879V21.4114H7.76471V22.5879Z"
        fill="#787878"
      />
      <path
        d="M7.76471 28.0003C7.11497 28.0003 6.58824 28.527 6.58824 29.1768C6.58824 29.8265 7.11497 30.3532 7.76471 30.3532V29.1768V28.0003ZM7.76471 29.1768V30.3532H39.0587V29.1768V28.0003H7.76471V29.1768Z"
        fill="#787878"
      />
      <path
        d="M7.76471 34.5882C7.11497 34.5882 6.58824 35.1149 6.58824 35.7646C6.58824 36.4144 7.11497 36.9411 7.76471 36.9411V35.7646V34.5882ZM7.76471 35.7646V36.9411H39.0587V35.7646V34.5882H7.76471V35.7646Z"
        fill="#787878"
      />
      <path
        d="M7.76471 41.1761C7.11497 41.1761 6.58824 41.7028 6.58824 42.3525C6.58824 43.0023 7.11497 43.529 7.76471 43.529V42.3525V41.1761ZM7.76471 42.3525V43.529H73.6468V42.3525V41.1761H7.76471V42.3525Z"
        fill="#787878"
      />
      <path
        d="M7.76471 47.7649C7.11497 47.7649 6.58824 48.2917 6.58824 48.9414C6.58824 49.5912 7.11497 50.1179 7.76471 50.1179V48.9414V47.7649ZM7.76471 48.9414V50.1179H73.6468V48.9414V47.7649H7.76471V48.9414Z"
        fill="#787878"
      />
      <rect
        x="38.6666"
        width="77.4899"
        height="44.3692"
        rx="3.76469"
        fill="#F5A801"
      />
      <path d="M108.97 49.056L99.5961 44.3691H108.97V49.056Z" fill="#F5A801" />
    </svg>
  );
}
